import Vue from 'vue'
const preventReClick = Vue.directive('preventReClick', {
	inserted: function (el, binding, vNode, oldVnode) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true
				setTimeout(() => {
					el.disabled = false
				}, 3000)
			}
		})
	}
})

const track = Vue.directive('track', {
	inserted: function (el, binding, vNode, oldVnode) {
		el.addEventListener('click', () => {
			const { value } = binding;
			const trackPurpose = el.dataset.trackPurpose || value;
			if (trackPurpose && window.mixpanel) {
				// Get current route name as page name
				const pageName = vNode.context.$route.name || (window.location.pathname.replace(/\//g, '').replace(/-/g, '_') || 'home');
				window.mixpanel.track(`${pageName}-${trackPurpose}_click`, {
					element: trackPurpose,
					page_name: pageName,
					timestamp: new Date().toISOString()
				});
			}
		})
	}
})

export default {
	preventReClick,
	track
}
